import { BerthBM } from '../types/BusinessModel/BerthBM';
import { BerthBMV2 } from '../types/BusinessModel/BerthBMV2';
import { BerthDataBM } from '../types/BusinessModel/BerthData';
import { Berth } from '../types/ViewModel/Berth';
import { BerthData } from '../types/ViewModel/BerthData';
import { BerthV2 } from '../types/ViewModel/BerthV2';
import { Terminal } from '../types/ViewModel/Terminal';

export class BerthFactory {
    constructor() {}

    public newBerth(berth: BerthBM, terminal: Terminal | null): Berth {
        return new Berth(
            berth.berthId,
            berth.terminalId,
            terminal,
            berth.berthShortName,
            berth.berthLongName,
            berth.imosBerthId,
            berth.imosExternalRef,
            berth.changedBy,
            berth.isDeleted,
            berth.lastUpdated
        );
    }

    public newBerthV2 = (bm: BerthBMV2): BerthV2 => {
        return {
            berthId: bm.berthId,
            portId: bm.portId,
            berthShortName: bm.berthShortName,
            berthLongName: bm.berthLongName,
        };
    };

    public newBertData(berthData: BerthDataBM): BerthData {
        return new BerthData(this.newBerthList(berthData.berthList));
    }

    public newBerthFromCode(berth: Berth, terminal: Terminal | null) {
        return new Berth(
            berth.berthId,
            berth.terminalId,
            terminal,
            berth.berthShortName,
            berth.berthLongName,
            berth.imosBerthId,
            berth.imosExternalRef,
            berth.changedBy,
            berth.isDeleted,
            berth.lastUpdated
        );
    }

    private sortDate(a: Date, b: Date) {
        if (a > b) {
            return -1;
        }
        if (a < b) {
            return 1;
        }
        return 0;
    }

    public newBerthList(berthList: BerthBM[]): Berth[] {
        const berths: Berth[] = [];
        if (berthList && berthList.length > 0) {
            berthList.map((b) => {
                berths.push(this.newBerth(b, null));
            });
        }
        return berths;
    }

    public newBerthV2List = (bms: BerthBMV2[]) => bms.map(this.newBerthV2);

    public newEmptyBerth(berthId: number, name: string | null) {
        return new Berth(berthId, null, null, null, name, null, null, '', false, null);
    }
}
